import React from "react";

const PaperClip = (props) => (
    <svg
        width={23}
        height={12}
        viewBox="0 0 23 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.5 10H6C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2H18.5C19.88 2 21 3.12 21 4.5C21 5.88 19.88 7 18.5 7H8C7.45 7 7 6.55 7 6C7 5.45 7.45 5 8 5H17.5V3.5H8C6.62 3.5 5.5 4.62 5.5 6C5.5 7.38 6.62 8.5 8 8.5H18.5C20.71 8.5 22.5 6.71 22.5 4.5C22.5 2.29 20.71 0.5 18.5 0.5H6C2.96 0.5 0.5 2.96 0.5 6C0.5 9.04 2.96 11.5 6 11.5H17.5V10Z"
            fill="#284F83"
        />
    </svg>
);

export default PaperClip;